import React from 'react'
import { Spin } from 'antd'

export default function PageLoading() {
    return <Spin className="spin-loader" size="large"/>
}
